export default __webpack_public_path__ + "static/media/ga ticket pass.998aed25.png";